import shortid from "shortid"
import Objdict from "objdict"

import Stage from "@frog/source/models/Stage.js"
import Step from "@frog/source/models/Step.js"
import Zone from "@frog/source/models/Zone.js"
import Reactions from "@frog/source/models/Reactions.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Dev from "@frog/source/models/admin/Dev.js"
import Random from "@frog/source/utility/Random.js"

import Speedtest from "@frog/source/tests/utility/Speedtest.js"

const MAX_INFLUENCE = 200 // this is duped in Stage.js
const INFLUENCE_ITERATIONS = 10
const INFLUENCE_DECAY = 20

const MOVE_COST = 1

import skills from "@frog/source/data/skills.js"
import units from "@frog/source/data/units.js"

import World from "@frog/source/models/World.js"

export default class Unit {
    static instantiate({unit, player}) {
        let partyUnit = player?.party?.units[unit.key] || {}
        const baseUnit = {
            "key": shortid.generate(),
            "energy": {"move": true, "invoke skill": true},
            "inventory": {"items": {}},
            "effects": {},
            "skills": [],
            "equippedSkills": {},
            "position": {"x": 0, "y": 0, "z": 0},
            "state": "idle", // or "aggroed"
            "maxhealth": 5,
        }

        unit = Objdict.merge(partyUnit, unit)

        let unitJob = {}
        if(unit.randomJobKey != undefined) {
            const jobKeys = []
            unit.randomJobKey.split(",").forEach((jobKey) => {
                jobKey = jobKey.trim()
                jobKeys.push(jobKey)
            })
            unit.jobKey = Random.element(jobKeys)
        }
        if(unit.jobKey != undefined) {
            unitJob = units[unit.jobKey] || {}
            if(units[unit.jobKey] == undefined) {
                console.log("Could not find unit class", unit.jobKey, unit)
            }
        }

        const mergedUnit = Objdict.merge(baseUnit, unitJob, unit)

        delete unit.actionmap // we do not instantiate action maps!!!

        mergedUnit.maxhealth = mergedUnit.maxhealth ?? 0
        mergedUnit.maxarmor = mergedUnit.maxarmor ?? 0
        if(mergedUnit.health === undefined) {
            mergedUnit.health = mergedUnit.maxhealth
        }
        if(mergedUnit.armor === undefined
        && mergedUnit.maxarmor !== undefined) {
            mergedUnit.armor = mergedUnit.maxarmor
        }

        // if(mergedUnit.position == undefined) {
        //     throw new Error("Unit.instantiate needs position")
        // }
        if(mergedUnit.skills == undefined) {
            throw new Error("Unit.instantiate needs skills")
        }
        if(mergedUnit.equippedSkills == undefined) {
            throw new Error("Unit.instantiate needs skills")
        }
        // if(mergedUnit.images == undefined) {
        //     throw new Error("Unit.instantiate needs images")
        // }

        // if(mergedUnit.unlockedSkills != undefined) {
        //     mergedUnit.skills = mergedUnit.skills.concat(mergedUnit.unlockedSkills)
        //     delete mergedUnit.unlockedSkills
        // }

        return mergedUnit
    }
    static computeInfluenceMap(affiliation, stage, position) {
        let influence = {}

        Objdict.forEach(stage.units, (unit) => {
            if(unit.affiliation != affiliation
            && unit.affiliation != "none"
            && unit.type != "zone"
            && unit.isDead != true
            && unit.hasBeenRemoved != true) {
                influence[unit.position.x + "x" + unit.position.y] = MAX_INFLUENCE
            }
        })

        // Do a heatmap of heading towards goodies
        for(let i = 0; i < INFLUENCE_ITERATIONS; i += 1) {
            let nextInfluence = {}
            const INFLUENCE_ZONE = stage.encounters[stage.currentEncounter || 1] || {}
            for(let x = INFLUENCE_ZONE.x; x <= INFLUENCE_ZONE.x + INFLUENCE_ZONE.width; x += 1) {
                for(let y = INFLUENCE_ZONE.y; y <= INFLUENCE_ZONE.y + INFLUENCE_ZONE.height; y += 1) {
                    const terrain = stage.world.terrain[x + "x" + y]
                    if(terrain == undefined) continue
                    const z = terrain.position.z + terrain.size.z

                    const position = {x, y, z}
                    nextInfluence[position.x + "x" + position.y] = influence[position.x + "x" + position.y] || 0
                    Geometry.getNeighborPoints(position).forEach((nextPosition) => {
                        const collision = Stage.findCollision({
                            "stage": stage,
                            "previousPosition": position,
                            "nextPosition": nextPosition
                        })

                        if(collision != undefined) {
                            if(collision.type == "world") return
                        }
                        const value = (influence[nextPosition.x + "x" + nextPosition.y] || 0) - INFLUENCE_DECAY
                        if(nextInfluence[position.x + "x" + position.y] < value) {
                            nextInfluence[position.x + "x" + position.y] = value
                        }
                    })
                }
            }
            influence = nextInfluence
        }

        // // Do a heatmap of heading towards the center of the map.
        // const LONGEST_DISTANCE = 13
        // const zone = stage.encounters[stage.currentEncounter || 1].zone || {}
        // const centerpoint = {
        //     "x": zone.x + (zone.width / 2),
        //     "y": zone.y + (zone.height / 2),
        // }
        // for(let x = 0; x <= stage.world.width; x += 1) {
        //     for(let y = 0; y <= stage.world.height; y += 1) {
        //         const terrain = stage.world.terrain[x + "x" + y]
        //         if(terrain == undefined) continue
        //         const z = terrain.position.z + terrain.size.z
        //         const position = {x, y, z, "key": x + "x" + y}
        //
        //         influence[position.key] = (1 - (Geometry.distance(position, centerpoint) / LONGEST_DISTANCE)) * MAX_INFLUENCE
        //     }
        // }

        // // Do a heatmap of heading towards the CLOSEST goodie.
        // const LONGEST_DISTANCE = 13
        // const targetUnit = Object.values(stage.units).filter((unit) => {
        //     return unit.affiliation == "good"
        //         && unit.hasBeenRemoved != true
        //         && unit.isDead != true
        //         && unit.type != "zone"
        // }).map((unit) => {
        //     return {unit, "distance": Geometry.distance(unit.position, position)}
        // }).sort((a, b) => {
        //     if(a.distance < b.distance) return -1
        //     if(a.distance > b.distance) return +1
        //     return 0
        // })[0]
        // for(let x = 0; x <= stage.world.width; x += 1) {
        //     for(let y = 0; y <= stage.world.height; y += 1) {
        //         const terrain = stage.world.terrain[x + "x" + y]
        //         if(terrain == undefined) continue
        //         const z = terrain.position.z + terrain.size.z
        //         const position = {x, y, z, "key": x + "x" + y}
        //
        //         influence[position.key] = (1 - (Geometry.distance(position, targetUnit.position) / LONGEST_DISTANCE)) * MAX_INFLUENCE
        //     }
        // }

        return influence
    }

    // This function will return an actionmap, a
    // hash of all the possible actions the given
    // unit could perform within range. An "action"
    // can be a move, an attack, an assist, etc.
    static calculateActions(performerKey, stage) {
        const mark = Speedtest.mark("Actions", "Unit.calculateActions")

        if(stage == undefined) throw new Error("requires action.stage")
        if(performerKey == undefined) throw new Error("requires action.performerKey")

        const startingAction =  {}

        const performer = stage.units[performerKey]
        if(performer == undefined) {
            throw new Error("Could not find unit " + performerKey + " in the stage.")
        }

        if(performer.isDead) {
            return
        }

        startingAction.performerKey = performerKey
        startingAction.isStartingAction = true
        startingAction.type = performer.energy["move"] == true ? "wait" : "wait - invoke skill"
        startingAction.position = performer.position
        startingAction.alphastage = startingAction.omegastage = Stage.copy(stage)
        startingAction.distance = performer.energy["move"] == true ? 0 : performer.moverange.max
        startingAction.steps = []

        const submark = Speedtest.mark("Unit.calculateAction", "influence map")
        startingAction.influenceMap = Unit.computeInfluenceMap(performer.affiliation, startingAction.alphastage, performer.position)
        submark()

        const actionmap = {}

        Unit.populateActionMap(actionmap, startingAction)
        Unit.pruneInternalActionMapData(actionmap)

        mark()
        return actionmap
    }
    static populateActionMap(actionmap, stubAction) {
        const calculatedAction = Unit.calculateAction(stubAction)
        if(calculatedAction == undefined) return
        Unit.saveAction(actionmap, calculatedAction)
        if(calculatedAction.nextActions != undefined) {
            calculatedAction.nextActions.forEach((nextAction) => {
                Unit.populateActionMap(actionmap, nextAction)
            })
        }
    }
    static calculateAction(action) {
        const mark1 = Speedtest.mark("Unit.calculateAction", "initialization")

        if(action.type === undefined) throw new Error("requires action.type")
        if(action.position === undefined) throw new Error("requires action.position")
        if(action.performerKey === undefined) throw new Error("requires action.performerKey")
        if(action.alphastage === undefined) throw new Error("requires action.alphastage")

        action.alphastage = Stage.copy(action.alphastage)

        // If nothing else happens, the omegastage
        // will match the alphastage. But throughout
        // this action, the omegastage will be cloned
        // and edited via the game logic.
        action.omegastage = action.alphastage

        action.positions = [{...action.position, "type": action.type}]
        action.steps = []

        if(action.previousAction != undefined) {
            action.positions = action.positions.concat(action.previousAction.positions)

            // TODO: we really reusing these and not recomputing these?
            action.steps = action.steps.concat(action.previousAction.steps.filter((step) => {
                return step.type != "exhaust energy"
                    && step.type != "increment stage.actionMark"
                    && step.type != "recalculate light"
            }))
            // if(action.steps.length > 0) {
            //     action.omegastage = action.steps[action.steps.length-1].omegastage
            // }
            // TODO: YOU REALLY CAN't JUST FILTER THE STEPS AND NOT ASSUME THE OMEGASTAGE
            // IS ALSO FILTERED; IT WAS BUIlT ON EACH OF THOSE STEPS IN TURN, SO IT IS
            // STILL TRUE EVEN IF YOU REMOVE THE STEPS!!
        }

        mark1()

        ///////////////////////////////
        // Unit-to-World Collision  //
        /////////////////////////////

        const mark2 = Speedtest.mark("Unit.calculateAction", "unit-to-world collision")

        const previousPosition = action.positions[1] || action.position
        const nextPosition = action.positions[0] || action.position

        if(action.type == "invoke skill") {
            if(World.isOutOfBounds(action.alphastage.world, nextPosition)) {
                mark2()
                return
            }
            if(Zone.isOutOfBounds(action.alphastage.encounters[action.alphastage.currentEncounter || 1].zone, nextPosition)) {
                mark2()
                return
            }
            const skill = skills.get(action.skillKey)
            if(skill == undefined) {
                mark2()
                return
            }

            if(skill.range && skill.range.type != "arc") {
                if(Dev.isAllyCollisionEnabled == true
                && World.hasCollision({
                    "world": action.alphastage.world,
                    previousPosition, nextPosition,
                    "zone": action.alphastage.encounters[action.alphastage.currentEncounter || 1].zone,
                })) {
                    mark2()
                    return
                }

                // const previousTerrain = World.getTerrain(action.alphastage.world, previousPosition)
                // const nextTerrain = World.getTerrain(action.alphastage.world, nextPosition)
                // const zDistance = Math.abs((previousTerrain.position.z + previousTerrain.size.z) - (nextTerrain.position.z + nextTerrain.size.z))
                // // Let units move between blocks if there is only
                // // a half-block delta! (ramps are considered half-blocks)
                // const MOVEMENT_SIZE = 1
                // if(zDistance <= MOVEMENT_SIZE) {
                //     action.position.z = nextTerrain.position.z + nextTerrain.size.z
                // }
            }

            // if(skill.range && skill.range.type == "arc") {
            //     const nextTerrain = World.getTerrain(action.alphastage.world, nextPosition)
            //     if(nextTerrain != undefined) {
            //         // if(nextTerrain.shape == "obstruction") {
            //         //     mark2()
            //         //     return
            //         // }
            //         action.position.z = nextTerrain.position.z + nextTerrain.size.z
            //     }
            // }
        }

        if(action.type == "move") {
            const alphaperformer = action.alphastage.units[action.performerKey]
            if(alphaperformer.movetype == "flying") {
                if(Dev.isAllyCollisionEnabled == true
                && World.isOutOfBounds(action.alphastage.world, nextPosition)) {
                    mark2()
                    return
                }
            } else {
                if(Dev.isAllyCollisionEnabled == true
                && World.hasCollision({
                    "world": action.alphastage.world,
                    previousPosition, nextPosition,
                    "zone": action.alphastage.encounters[action.alphastage.currentEncounter || 1].zone,
                })) {
                    mark2()
                    return
                }

                if(action.distance > 0) {
                    const nextTerrain = World.getTerrain(action.alphastage.world, nextPosition)
                    if(nextTerrain != undefined
                    && nextTerrain.isTree == true) {
                        if(alphaperformer.movetype == "mounted") {
                            mark2()
                            return
                        }
                        if(action.distance > MOVE_COST) {
                            mark2()
                            return
                        }
                        action.distance += MOVE_COST * 3
                    }
                }
            }
        }

        mark2()

        /////////////////////////////
        // Unit-to-Unit Collision //
        ///////////////////////////

        const mark3 = Speedtest.mark("Unit.calculateAction", "unit-to-unit collision")

        if(action.type == "move") {
            const performer = action.alphastage.units[action.performerKey]
            const positionedUnits = Stage.findUnitsByPosition(action.alphastage, action.position, {"excludeUnitKey": action.performerKey, "includingZones": true})
            let collidingUnit = positionedUnits.find((unit) => {
                if(Dev.isAllyCollisionEnabled != true
                && performer.affiliation == "good") {
                    return false
                }

                if(unit == undefined) return
                if(unit.type == "zone") {
                    return false
                }

                if(unit.affiliation == performer.affiliation) {
                    action.type = "move through"
                    return false
                } else {
                    action.type = "move - colliding unit"
                    return true
                }
            })

            if(collidingUnit != undefined) {
                mark3()
                return
            }
        }

        if(action.type == "invoke skill"
        && skills.get(action.skillKey).canTarget instanceof Function) {
            if(skills.get(action.skillKey).canTarget({"performerKey": action.performerKey, "stage": action.alphastage, "position": action.position}) == false) {
                action.type = "invoke skill - can not target"
                if(skills.get(action.skillKey).isRenderedEvenIfCanNotTarget != true) {
                    mark3()
                    return
                }
            }
        }

        mark3()

        ///////////////////////////////
        // Calculate the Omegastage //
        /////////////////////////////

        const mark4 = Speedtest.mark("Unit.calculateAction", "omegastage calculation")

        if(action.type == "wait") {
            Action.addStep(action, Step.instantiate({
                "type": "exhaust energy",
                "alphastage": action.omegastage,
                "deltastages": [
                    {
                        "units": {
                            [action.performerKey]: {
                                "energy": {
                                    "move": false,
                                    // "invoke skill": true,
                                }
                            }
                        }
                    },
                ]
            }))
        }

        if(action.type == "move"
        || action.type == "move through") {
            if(action.direction != undefined) {
                Action.addStep(action, Step.instantiate({
                    "type": "turn",
                    "alphastage": action.omegastage,
                    "deltastages": [
                        {
                            "unit": {
                                "key": action.performerKey,
                                "direction": action.direction,
                            }
                        }
                    ]
                }))
            }
            const performer = action.omegastage.units[action.performerKey]
            Action.addStep(action, Step.instantiate({
                // "type": performer.affiliation != "good" ? "move" : "move-without-animation",
                "type": "move",
                "affiliation": performer.affiliation, // DEBUG
                "alphastage": action.omegastage,
                "deltastages": [
                    {
                        "annotation": {
                            "unitReference": performer.reference,
                            "unitKey": performer.key,
                        },
                        "units": {
                            [action.performerKey]: {
                                "position": {
                                    "mode": "absolute",
                                    "x": action.position.x,
                                    "y": action.position.y,
                                    "z": action.position.z,
                                },
                            }
                        }
                    }
                ]
            }))

            Action.addStep(action, Reactions.getSteps(action.omegastage))

            // TODO: why is there logic aroundthis? of course we exhaust the energy!!
            // const omegaperformer = action.omegastage.units.find((unit) => unit.key == action.performerKey)
            if(action.type == "move") {
            // && action.distance >= omegaperformer.moverange
            // && omegaperformer.energy.move != true) {
                Action.addStep(action, Step.instantiate({
                    "type": "exhaust energy",
                    "alphastage": action.omegastage,
                    "deltastages": [
                        {
                            "units": {
                                [action.performerKey]: {
                                    "energy": {
                                        "move": false,
                                    }
                                }
                            }
                        },
                    ]
                }))
            }
        }


        if(action.type == "invoke skill"
        && action.skillKey != undefined) {
            if(action.direction != undefined) {
                Action.addStep(action, Step.instantiate({
                    "type": "turn",
                    "alphastage": action.omegastage,
                    "deltastages": [
                        {
                            "unit": {
                                "key": action.performerKey,
                                "direction": action.direction,
                            }
                        }
                    ]
                }))
            }

            // const performer = action.omegastage.units[action.performerKey]
            // const target = Stage.findUnitAtPosition(action.omegastage, action.position)
            // if(target != undefined) {
            //     action.targetAffiliation = target.affiliation
            // }
            //
            //
            // // CONVO // DEBUG
            // const conversation = getConversation(action)
            //
            // if(conversation != undefined
            // && conversation.dialogue != undefined) {
            //     conversation.dialogue.forEach((dialogue) => {
            //         Action.addStep(action, Step.instantiate({
            //             "type": "say",
            //             "alphastage": action.omegastage,
            //
            //             "deltastages": [
            //                 {
            //                     "mark": 0,
            //                     "dialogue": {
            //                         "text": dialogue.text,
            //                         "portrait": dialogue.portrait,
            //                     }
            //                 }
            //             ],
            //             "isImportant": true,
            //             "duration": Infinity,
            //         }))
            //     })
            //     Action.addStep(action, Step.instantiate({
            //         "type": "unsay",
            //         "alphastage": action.omegastage,
            //         "deltastages": [
            //             {
            //                 "mark": 0,
            //                 "dialogue": null
            //             }
            //         ],
            //     }))
            // }
            //
            // if(conversation != undefined
            // && conversation.changeTargetAffilationTo != undefined) {
            //     Action.addStep(action, Step.instantiate({
            //         "alphastage": action.omegastage,
            //         "deltastages": [
            //             {
            //                 "mark": 0,
            //                 "unit": {
            //                     "key": target.key,
            //                     "affiliation": conversation.changeTargetAffilationTo == "me" ? action.alphastage.units[action.performerKey].affiliation : conversation.changeTargetAffilationTo,
            //                 }
            //             }
            //         ],
            //     }))
            // }
            //
            // if(conversation == undefined
            // || conversation.type == "invoke skill"
            // || conversation.alsoInvokeSkill == true) {
            const skill = skills.get(action.skillKey)

            action.role = skill.role

            if(skill.calculateStep instanceof Function) {
                const step = skill.calculateStep({
                    "performerKey": action.performerKey,
                    "position": action.position,
                    "stage": action.omegastage,
                })
                Action.addStep(action, step)
                if(step.followupSteps != undefined) {
                    step.followupSteps.forEach((followupStep) => {
                        Action.addStep(action, followupStep)
                        // TODO: Do we have any gaurentee that these
                        // followup steps are respecting the invoke skill step.omegastage?
                        // and that we can use it without killing and undoing the invoke skill?
                    })
                }
            } else {
                // TODO: Deprecate this!!
                Action.addStep(action, Step.instantiate({
                    "type": "invoke skill",
                    "skillKey": action.skillKey,
                    "alphastage": action.omegastage,
                    "deltastages": skill.calculateDeltastages({
                        "performerKey": action.performerKey,
                        "position": action.position,
                        "stage": action.omegastage,
                    }),
                }))
            }

            // if(action.position.x == 7 && action.position.y == 4
            // || action.position.x == 8 && action.position.y == 2
            // || action.position.x == 10 && action.position.y == 3) {
            //     const performer = action.omegastage.units[action.performerKey]
            //     if(performer.affiliation == "good"
            //     && GREEDY_DIALOGUE[performer.class] != undefined) {
            //         GREEDY_DIALOGUE[performer.class].forEach((dialogue) => {
            //             Action.addStep(action, Step.instantiate({
            //                 "type": "say",
            //                 "alphastage": action.omegastage,
            //
            //                 "deltastages": [
            //                     {
            //                         "mark": 0,
            //                         "dialogue": dialogue
            //                     }
            //                 ],
            //                 "isImportant": true,
            //                 "duration": Infinity,
            //             }))
            //         })
            //         Action.addStep(action, Step.instantiate({
            //             "type": "unsay",
            //             "alphastage": action.omegastage,
            //             "deltastages": [
            //                 {
            //                     "mark": 0,
            //                     "dialogue": null
            //                 }
            //             ],
            //         }))
            //     }
            // }

            /////////////
            // DEATHS //
            ///////////
            Action.addStep(action, Reactions.getSteps(action.omegastage))
            if(action.omegastage.units[action.performerKey] == undefined) {
                return action
            }

            // BETRAYAL_DIALOGUE //

            // const target = Stage.findUnitAtPosition(action.alphastage, action.position)
            // if(target != undefined) {
            //     const alphaunit = action.alphastage.units[target.key]
            //     const omegaunit = action.omegastage.units[target.key]
            //     if(alphaunit != undefined
            //     && omegaunit != undefined
            //     && alphaunit.affiliation != omegaunit.affiliation
            //     && omegaunit.isDead != true) {
            //         if(BETRAYAL_DIALOGUE[unit.class] != undefined) {
            //             BETRAYAL_DIALOGUE[unit.class].forEach((dialogue) => {
            //                 Action.addStep(action, Step.instantiate({
            //                     "type": "say",
            //                     "alphastage": action.omegastage,
            //
            //                     "deltastages": [
            //                         {
            //                             "mark": 0,
            //                             "dialogue": dialogue
            //                         }
            //                     ],
            //                     "isImportant": true,
            //                     "duration": Infinity,
            //                 }))
            //             })
            //             Action.addStep(action, Step.instantiate({
            //                 "type": "unsay",
            //                 "alphastage": action.omegastage,
            //                 "deltastages": [
            //                     {
            //                         "mark": 0,
            //                         "dialogue": null
            //                     }
            //                 ],
            //             }))
            //         }
            //     }
            // }

            //////////////////////
            // COUNTER-ATTACKS //
            ////////////////////

            if(skills.get(action.skillKey).canBeCounterattacked) {
                const targetedUnit = Stage.findUnitAtPosition(action.alphastage, action.position)
                if(targetedUnit != undefined
                && action.omegastage.units[targetedUnit.key] != undefined
                && action.omegastage.units[targetedUnit.key].isDead != true) {
                    const target = action.omegastage.units[targetedUnit.key]
                    const performer = action.omegastage.units[action.performerKey]
                    const counterattackSkillKey = Objdict.find(target.skills, (skillKey) => {
                        return skills.get(skillKey) != undefined
                            && (skills.get(skillKey).type == "counterattack" || skills.get(skillKey).canCounterattack)
                            && Geometry.isWithinRange(target.position, performer.position, skills.get(skillKey).range || target.attackrange) // DOES NOT RESPECT Z
                            && (skills.get(skillKey).canTarget instanceof Function == false
                            || skills.get(skillKey).canTarget({"performerKey": target.key, "stage": action.omegastage, "position": performer.position}) == true)
                            // If you ever want this to be a "on damage" rather than a fire-emblem-style counterattack
                            // then remove this Geometry.isWithinRange condition.
                    })
                    // const vector = Geometry.difference(performer.position, target.position)
                    // const direction = {"x": 0, "y": 0}
                    // if(vector.x == 0 && vector.y != 0) {
                    //     direction.y = Math.sign(vector.y)
                    // } else if(vector.x != 0 && vector.y == 0) {
                    //     direction.x = Math.sign(vector.x)
                    // } else if(vector.x != 0 && vector.y != 0) {
                    //     if(Math.abs(vector.x) > Math.abs(vector.y)) {
                    //         direction.x = Math.sign(vector.x)
                    //     } else {
                    //         direction.y = Math.sign(vector.y)
                    //     }
                    // }
                    // TODO: read a direction from the deltaunit, so the skills can define
                    // the direction of damage instead of this ungrokable math equation.
                    // const position = Geometry.add(target.position, direction)
                    if(counterattackSkillKey != undefined) {
                        const skill = skills.get(counterattackSkillKey)
                        if(skill.calculateStep instanceof Function) {
                            const step = skill.calculateStep({
                                "performerKey": target.key,
                                "position": performer.position,
                                "stage": action.omegastage,
                            })
                            Action.addStep(action, step)
                        } else {
                            // TODO: Deprecate this!!
                            Action.addStep(action, Step.instantiate({
                                "type": "invoke skill",
                                "alphastage": action.omegastage,
                                "deltastages": skill.calculateDeltastages({
                                    "performerKey": target.key,
                                    "position": performer.position,
                                    "stage": action.omegastage,
                                }),
                            }))
                        }
                    }
                }

                /////////////
                // DEATHS //
                ///////////
                Action.addStep(action, Reactions.getSteps(action.omegastage))
                if(action.omegastage.units[action.performerKey] == undefined) {
                    return action
                }
            }

            /////////////
            // ENERGY //
            ///////////
            Action.addStep(action, Step.instantiate({
                "type": "exhaust energy",
                "alphastage": action.omegastage,
                "deltastage": {
                    "unit": {
                        "key": action.performerKey,
                        "energy": {"invoke skill": false}
                    }
                }
            }))
        }

        // const light = "hello world"
        // Action.addStep(action, Step.instantiate({
        //     "type": "recalculate light",
        //     "alphastage": action.omegastage,
        //     "deltastages": [
        //         {
        //             "light": light
        //         }
        //     ]
        // }))

        // Action.addStep(action, Step.instantiate({
        //     "type": "increment stage.actionMark",
        //     "alphastage": action.omegastage,
        //     "deltastages": [{"actionMark": (action.omegastage.actionMark || 0) + 1}]
        // }))

        // /////////////////////
        // // Passive Skills //
        // ///////////////////
        // // NONE OF THESE RESPECT .SKILLKEY (OVER .SKILL)
        // Speedtest.point("apply passives")
        //
        // action.alphastage.units.forEach((shadowunit) => {
        //     if(shadowunit.skills != undefined) {
        //         shadowunit.skills.forEach((skill) => {
        //             if(skill.type == "passive"
        //             && skill.trigger == "reaction") {
        //                 skill.editResults(action, shadowunit)
        //             }
        //         })
        //     }
        // })

        // //////////////////////
        // // Counter-Attacks //
        // ////////////////////
        // // NONE OF THESE RESPECT .SKILLKEY (OVER .SKILL)
        // // DON'T WE ALREADY HAVE THIS UP ABOVE?
        /// /// DOES NOT RESPECT ACTION.PERFORMERKEY
        // Speedtest.point("predict counter-attacks")
        //
        // if(action.type === "invoke"
        // && action.skill.canBeCountered != true
        // && action.alphastage.units.target.health + ((action.results && action.results.target && action.results.target.health) || 0) > 0) {
        //     let counterskill = action.target.skills.find((skill) => {
        //         return skill.type == "counterattack"
        //             && skill.canTarget(action.performer, action.target, action, action.stage)
        //     })
        //     if(!!counterskill) {
        //         action.counterAction = {
        //             "type": "invoke",
        //             "skill": counterskill,
        //             "target": action.performer,
        //             "performer": action.target,
        //             "results": counterskill.calculateDeltastages(action.performer, action.target, true /*isCounterAction*/, {"units": action.alphastage.units}, action)
        //         }
        //     }
        // }
        //
        // // // TODO: also shadow the counter actions
        // // if(action.counterAction != undefined) {
        // //     if(action.counterAction.results != undefined
        // //     && action.counterAction.results.target != undefined
        // //     && action.counterAction.results.target.health != undefined) {
        // //         shadowunit.health += action.counterAction.results.target.health
        // //     }
        // //     // TODO: am i reading this right? we only predict target health for
        // //     // counteractions. no performer health, no target position.
        // // }

        // TODO: Aggregate all the step results into a common result object.

        // // TODO: Revisit calculating the FUTURE state of next turn if the
        // // players chose to end their turn right after this action, mostly
        // // including end-of-turn effects.
        // startTurnEffects.forEach((effect) => {
        //     const results = effect.calculateDeltastages({
        //         "previousState": action.quantumstate["turn:=0"]
        //     })
        //     Object.keys(results).forEach((key) => {
        //         const result = results[key]
        //         const unit = action.quantumstate["turn:+1:start"].units.find((unit) => unit.key == key)
        //         if(unit != undefined) {
        //             unit.health += result.health
        //             unit.isDead = unit.health <= 0
        //         }
        //     })
        // })
        // action.quantumstate["turn:+1:start"] = {
        //     // "units": action.shadowunits.map((unit) => {
        //     //     return {
        //     //         "key": unit.key,
        //     //         "delta": {"health": 0},
        //     //         "alpha": clonedeep(unit),
        //     //         "omega": {/*to be computed*/}
        //     //     }
        //     // }),
        //     "tiles": clonedeep(action.shadowtiles),
        //     "units": clonedeep(action.shadowunits),
        // }
        mark4()

        ///////////////////
        // FLOW ACTIONS //
        /////////////////

        // This is where we flow to all the neighboring
        // tiles. These checks do not verify whether the
        // unit can move to this tile or act on this tile,
        // but it does propagate the actions to check.

        action.nextActions = []

        const mark7 = Speedtest.mark("Unit.flowActions", "flow: move")
        const omegaperformer = action.omegastage.units[action.performerKey]

        // // CHESS
        // if(action.isStartingAction) {
        //     const subclasses = omegaperformer.subclasses || {"1": omegaperformer}
        //     Objdict.forEach(subclasses, (subclass, subclassIndex) => {
        //         if(subclass.moverange != undefined
        //         && subclass.moverange.directions != undefined
        //         && omegaperformer.energy[subclassIndex] !== false) {
        //             subclass.moverange.directions.forEach((direction) => {
        //                 action.nextActions.push({
        //                     "type": "move",
        //                     "performerKey": action.performerKey,
        //                     "subclassIndex": subclassIndex,
        //                     "position": Geometry.add(action.position, direction),
        //                     "distance": action.distance + MOVE_COST,
        //                     "alphastage": action.omegastage,
        //                     "previousAction": action, // used for steps and positions
        //                     "influenceMap": action.influenceMap,
        //                     "direction": direction
        //                 })
        //             })
        //         }
        //     })
        // } else {
        //     if(action.type == "move"
        //     || action.type == "wait"
        //     || action.type == "move through") {
        //         const subclasses = omegaperformer.subclasses || {"1": omegaperformer}
        //         if(omegaperformer.isDead != true
        //         // && omegaperformer.energy["move"] == true
        //         // && Unit.isFlinching(omegaperformer) == false
        //         && action.distance < subclasses[action.subclassIndex].moverange.max) {
        //             // if(action.positions.find((previousPosition) => Geometry.equals(previousPosition, nextPostion))) {
        //             //     return
        //             // }
        //
        //             action.nextActions.push({
        //                 "type": "move",
        //                 "performerKey": action.performerKey,
        //                 "position": Geometry.add(action.position, action.direction),
        //                 "distance": action.distance + MOVE_COST,
        //                 "alphastage": action.omegastage,
        //                 "previousAction": action, // used for steps and positions
        //                 "influenceMap": action.influenceMap,
        //                 "direction": action.direction,
        //                 "subclassIndex": action.subclassIndex,
        //             })
        //         }
        //     }
        // }

        // NOT CHESS
        if(action.type == "move"
        || action.type == "wait"
        || action.type == "move through") {
            if(omegaperformer.isDead != true
            // && omegaperformer.state != "idle"
            // && omegaperformer.energy["move"] == true
            && action.distance < omegaperformer.moverange
            && Unit.isFlinching(omegaperformer) == false) {
                Geometry.getNeighborPoints(action.position).forEach((neighborposition) => {
                    if(action.positions.find((previousPosition) => Geometry.equals(previousPosition, neighborposition))) {
                        return
                    }
                    const nextTerrain = World.getTerrain(action.alphastage.world, neighborposition)
                    if(nextTerrain == undefined) return // TODO: SHOULD WE REALLY BE DOING THE WORLD COLLISION CHECK HERE?
                    let distance = MOVE_COST
                    if(nextTerrain.isPath) distance = MOVE_COST / 2
                    // if(nextTerrain.isTree) distance = MOVE_COST * 2
                    if(action.distance + distance > omegaperformer.moverange) return
                    action.nextActions.push({
                        "type": "move",
                        "performerKey": action.performerKey,
                        "position": neighborposition,
                        "distance": action.distance + distance,
                        "alphastage": action.omegastage,
                        "previousAction": action, // used for steps and positions
                        "influenceMap": action.influenceMap,
                        "direction": Geometry.direction(neighborposition, action.position),
                    })
                })
            }
        }
        mark7()

        const mark8 = Speedtest.mark("Unit.flowActions", "flow: invoke skill")
        if(action.type == "move"
        || action.type == "wait"
        || action.type == "wait - invoke skill") {
            if(omegaperformer.isDead != true
            && omegaperformer.energy["invoke skill"] == true
            && omegaperformer.skills != undefined) {
            // && Unit.isFlinching(omegaperformer) == false) {
                // const skillsToInvoke = ["support1", "support2", "attack1", "attack2", "attack3", "attack4", "attack5"]
                Object.values(omegaperformer.skills).forEach((skillKey) => {
                    // const skillKey = omegaperformer.skills[skillSlot]
                    if(skillKey == undefined
                    || skills.get(skillKey) == undefined) {
                        return
                    }
                    const skill = skills.get(skillKey)
                    if(skill.type == "invoke") {
                        let positions = []
                        if(skill.range != undefined && skill.range.type == "findCollisionInDirection") {
                            Object.values(Geometry.orthodirections).forEach((direction) => {
                                positions = positions.concat(Stage.findCollisionInDirection({
                                    "stage": action.omegastage,
                                    "position": omegaperformer.position,
                                    "direction": direction,
                                    "maxdistance": (skill.range && skill.range.max) || omegaperformer.attackrange,
                                    "options": (skill.range && skill.range.options),
                                }).positions)
                            })
                        } else {
                            positions = Geometry.getNeighborPoints(action.position, skill.range || omegaperformer.attackrange)
                        }

                        positions.forEach((position) => {
                            action.nextActions.push({
                                "type": "invoke skill",
                                "skillKey": skillKey,
                                "performerKey": action.performerKey,
                                "position": position,
                                "alphastage": action.omegastage,
                                "previousAction": action, // used for steps and positions
                                "influenceMap": action.influenceMap,
                                "direction": Geometry.direction(position, action.position),
                            })
                        })
                    }
                })
            }
        }
        mark8()

        return action
    }
    static saveAction(actionmap, action) {
        const mark = Speedtest.mark("Unit.calculateAction", "save the action")

        // What makes each action different, even if they share a position and performer?
        // distance is NOT the same
        // skill + type is NOT the same
        // prev actions are NOT the same
        // (probably more, now. this list is very old)

        action.key = action.type + ":" + action.positions.map(Geometry.toString).reverse().join(">")

        const positionkey = action.position.x + "x" + action.position.y // + "x" + action.position.z // DEBUG DID A BAD THING HUH
        actionmap[positionkey] = actionmap[positionkey] || []
        actionmap[positionkey].push(action)

        mark()
        return actionmap
    }
    static pruneInternalActionMapData(actionmap) {
        Objdict.forEach(actionmap, (actionmaptile) => {
            actionmaptile.forEach((action) => {
                delete action.previousAction
                delete action.nextActions
                delete action.isStartingAction
                // distance
                // influenceMap
                // performerKey
                // skillKey
                // type
                // steps
                // omegastage
                // alphastage
                // positions
                // position
            })
        })
        return actionmap
    }

    static copy(unit) {
        if(unit == undefined) return undefined
        return {
            "key": unit.key, // unit's individual unique key
            "reference": unit.reference, // unit's shared base class key
            "isDead": unit.isDead || false,
            "deathTimer": unit.deathTimer,
            "hasSlowDeath": unit.hasSlowDeath,
            "canBetray": unit.canBetray,
            "hasBeenRemoved": unit.hasBeenRemoved, // todo: THIS IS VICTORY CONDITION SPECIFIC
            "position": unit.position && {
                "x": unit.position.x,
                "y": unit.position.y,
                "z": unit.position.z,
            },
            "affiliation": unit.affiliation,
            "skills": unit.skills,
            "equippedSkills": unit.equippedSkills,
            // "unlockedSkills": unit.unlockedSkills,
            // "unlockableSkills": unit.unlockableSkills,
            "energy": {
                "move": unit.energy && unit.energy["move"],
                "invoke skill": unit.energy && unit.energy["invoke skill"],
                "1": unit.energy && unit.energy["1"],
                "2": unit.energy && unit.energy["2"],
            },
            "jobKey": unit.jobKey,
            "health": unit.health,
            "power": unit.power,
            "element": unit.element,
            "attacktype": unit.attacktype,
            "attackrange": unit.attackrange,
            "attackspeed": unit.attackspeed,
            "defense": unit.defense,
            "resistance": unit.resistance,
            "luck": unit.luck,
            "maxhealth": unit.maxhealth,
            "moverange": unit.moverange,
            "movetype": unit.movetype,
            "image": unit.image,
            "face": unit.face,
            "faceKey": unit.faceKey,
            "body": unit.body,
            "bodyKey": unit.bodyKey,
            "decalImageKey": unit.decalImageKey,
            "weaponImageKey": unit.weaponImageKey,
            "portrait": unit.portrait,
            "portrait_hidden": unit.portrait_hidden,
            "images": unit.images,
            "sprites": unit.sprites,
            "portraits": unit.portraits,
            "sounds": unit.sounds,
            "effects": Objdict.map(unit.effects, (effect) => {
                const reeffect = {
                    "type": effect.type,
                    "timer": effect.timer,
                }
                for(let key in effect) {
                    if(effect[key] != undefined) {
                        reeffect[key] = effect[key]
                    }
                }
                // if(effect["range"] !== undefined) reeffect["range"] = effect["range"] // TODO: make this a deeper copy, not a shallow copy
                // if(effect["actionMark"] !== undefined) reeffect["actionMark"] = effect["actionMark"]
                // if(effect["skillKey"] !== undefined) reeffect["skillKey"] = effect["skillKey"]
                // if(effect["positions"] !== undefined) reeffect["positions"] = effect["positions"]
                // // WE HAVE TO DO THIS TO SATISFY DUMB TEST COMPARES
                return reeffect
            }),
            "name": unit.name,
            // "number": unit.number, // THESE ARE STATIC DECORATOR META VALUES, WHICH WE
            // SHOULD SOMEDAY BE ABLE TO JUST READ FROM A REFERENCED PROTOTYPE PARENT.
            // "family": unit.family,
            "inventory": {
                "count": unit.inventory.count,
                "items": Objdict.map(unit.inventory.items, (item) => {
                    const copiedItem = {}
                    for(let key in item) {
                        if(item[key] != undefined) {
                            copiedItem[key] = item[key]
                        }
                    }
                    return copiedItem
                }),
            },
            "experience": unit.experience,
            "armor": unit.armor,
            "maxarmor": unit.maxarmor,
            "armortype": unit.armortype,
            "level": unit.level,
            "jobName": unit.jobName,
            "state": unit.state,
            "class": unit.class,
            "type": unit.type,
            "score": unit.score,
            "isVisible": unit.isVisible,
            "disableHealth": unit.disableHealth, // YIKES I WISH WE JUST DIDN'T ADD HEALTH TO BEGIN WITH (WITHOUT DEATH KICKING IN FOR THE HEALTHLESS ENTITY)
            "isHidingHealthbar": unit.isHidingHealthbar,
            "isNotRendered": unit.isNotRendered, // bruh
            "direction": unit.direction,
            "intent": unit.intent, // JUST FOR KILLZONES...?
            "canWalkOntoTheZone": unit.canWalkOntoTheZone, // i mean like ok this too...??
            "destination": unit.destination, // this is, like, a "generic" variable for tiled objects.. but this should be less singular and support multiple params.
            "spawnclass": unit.spawnclass, // uh yeah thisi sjust for spawn zones?? why does every unit have this??
            "properties": unit.properties, // generic immutable dict for properties?
            "item": unit.item, // just using this for animating an item above a character's head.
            "isRecruited": unit.isRecruited,
            "isRecruitable": unit.isRecruitable,
            "day": unit.day, // used in town,
            "subclasses": unit.subclasses,
            "tag": unit.tag, // using this for spawn point groups. spawn left or right, for example.
            "facts": unit.facts,
            "spawnspot": unit.spawnspot,
            "dialogue": unit.dialogue,
            "title": unit.title,
            "subtitle": unit.subtitle,
        }
    }

    //////////////
    // Getters //
    ////////////
    static isFlinching(unit) {
        if(unit.effects != undefined) {
            return !!Objdict.find(unit.effects, (effect) => {
                return effect.type == "flinch"
            })
        }
    }
}
// // THIS IS PRETTY OUT OF DATE
// const exampleAction = {
//     "type": String, // "move"|"invoke"|"assist"|"move through"|"invoke skill"
//     "stage": Stage,
//     "performer": Unit,
//     "target": Unit,
//     "position": Point, // position of this action
//     "distance": Number, // shortest orthogonal distance from the starting action.
//     "isStartingAction": Boolean,
//     // THE STATE **BEFORE** THE ACTION IS PERFORMED
//     "alphastage": {
//         "units": [{Unit}, {Unit}, {Unit}],
//         "tiles": [{Tile}, {Tile}, ..., {Tile}],
//     },
//     // THE STATE **AFTER** THE ACTION IS PERFORMED
//     "omegastage": {
//         "units": [{Unit}, {Unit}, {Unit}],
//         "tiles": [{Tile}, {Tile}, ..., {Tile}],
//     },
//     "results": {
//         "target": {
//             "health": -1, // remove one health
//             "position": {"x": -1, "y": 0}, // move left one tile
//         },
//         "peformer": {
//             "health": +1
//         },
//     },
//     "counterAction": Action,
// }

// TODO: hey is it documented anywhere that action.positions are in reverse order, so action.positions[0] is the current position, and action.positions[1] is the last position?

import Delta from "@frog/source/models/Delta.js"

class Action {
    static addStep(action, step) {
        if(step == undefined) return
        if(step instanceof Array == false) {
            step = [step]
        }
        step.forEach((step) => {
            action.omegastage = step.omegastage
            action.steps.push(step)
        })
    }
}

// ACTIONS is a single discrete input that the player/ai has
// chosen. They are legal actions to perform from the current
// state: within range, respecting targets, etc. They include
// a list of steps/beats.

// STEPS/BEATS are the execution of an action, or a script.
// They include there own discrete edit onto the world, with
// all the details necessary to perform it. It includes both
// the state BEFORE and AFTER the step is performed. They can
// be overlapped or combined by the director.
